/*
 * PROD-7828 R9 — the CSV upload contract as hridaya mirrors it. Every constant here is pinned by
 * params.test.js against the additional_upload_enums fixture (synced from goserver), so a code,
 * verdict or limit the server changes fails the suite instead of the panel.
 */

// Every code an upload endpoint (and /recalc) can answer with; error_handlers.js maps each one.
export const UPLOAD_ERROR = {
  INVALID_REQUEST: 'INVALID_REQUEST',
  INVALID_PAY_MONTH: 'INVALID_PAY_MONTH',
  PAY_MONTH_OUTSIDE_WINDOW: 'PAY_MONTH_OUTSIDE_WINDOW',
  FILE_TOO_LARGE: 'FILE_TOO_LARGE',
  FILE_NOT_CSV: 'FILE_NOT_CSV',
  FILE_EMPTY: 'FILE_EMPTY',
  MISSING_COLUMN: 'MISSING_COLUMN',
  UNKNOWN_COLUMN: 'UNKNOWN_COLUMN',
  DUPLICATE_COLUMN: 'DUPLICATE_COLUMN',
  ROW_LIMIT_EXCEEDED: 'ROW_LIMIT_EXCEEDED',
  FILE_ALREADY_APPLIED: 'FILE_ALREADY_APPLIED',
  REASON_REQUIRED: 'REASON_REQUIRED',
  RUN_NOT_YOURS: 'RUN_NOT_YOURS',
  RUN_NOT_FOUND: 'RUN_NOT_FOUND',
  TEACHER_NOT_FOUND: 'TEACHER_NOT_FOUND',
  RUN_DISCARDED: 'RUN_DISCARDED',
  ALREADY_APPLIED: 'ALREADY_APPLIED',
  INVALID_ROWS_NOT_ACKNOWLEDGED: 'INVALID_ROWS_NOT_ACKNOWLEDGED',
  CONFIRMATION_REQUIRED: 'CONFIRMATION_REQUIRED',
  NOTHING_TO_APPLY: 'NOTHING_TO_APPLY',
  PREVIEW_STALE: 'PREVIEW_STALE',
  IDEMPOTENCY_MISMATCH: 'IDEMPOTENCY_MISMATCH',
  MONTH_CLOSED: 'MONTH_CLOSED',
  MONTH_NOT_OPEN: 'MONTH_NOT_OPEN',
  PREVIOUS_MONTH_NO_RECORD: 'PREVIOUS_MONTH_NO_RECORD',
  UPLOAD_STORAGE_NOT_CONFIGURED: 'UPLOAD_STORAGE_NOT_CONFIGURED',
  UPLOAD_BUCKET_MISSING: 'UPLOAD_BUCKET_MISSING',
  UPLOAD_ACCESS_DENIED: 'UPLOAD_ACCESS_DENIED',
  UPLOAD_TIMED_OUT: 'UPLOAD_TIMED_OUT',
  UPLOAD_FAILED: 'UPLOAD_FAILED',
  FILE_LINK_UNAVAILABLE: 'FILE_LINK_UNAVAILABLE',
  FORBIDDEN: 'FORBIDDEN',
  LOOKUP_FAILED: 'LOOKUP_FAILED'
};

// Per-row verdict codes inside an UploadRun (codes[].code).
export const ROW_CODE = {
  INVALID_REQUEST: 'INVALID_REQUEST',
  INVALID_PAY_MONTH: 'INVALID_PAY_MONTH',
  PAY_MONTH_OUTSIDE_WINDOW: 'PAY_MONTH_OUTSIDE_WINDOW',
  UNKNOWN_CATEGORY: 'UNKNOWN_CATEGORY',
  SYSTEM_CATEGORY_NOT_SELECTABLE: 'SYSTEM_CATEGORY_NOT_SELECTABLE',
  ENTRY_TYPE_NOT_ALLOWED: 'ENTRY_TYPE_NOT_ALLOWED',
  INVALID_AMOUNT: 'INVALID_AMOUNT',
  AMOUNT_REQUIRED: 'AMOUNT_REQUIRED',
  AMOUNT_ABOVE_CAP: 'AMOUNT_ABOVE_CAP',
  INVALID_ENTRY_DATE: 'INVALID_ENTRY_DATE',
  NOTE_REQUIRED: 'NOTE_REQUIRED',
  INVALID_REFERENCE_ID: 'INVALID_REFERENCE_ID',
  REFERENCE_ID_REQUIRED: 'REFERENCE_ID_REQUIRED',
  RESERVED_REFERENCE_ID: 'RESERVED_REFERENCE_ID',
  TEACHER_NOT_FOUND: 'TEACHER_NOT_FOUND',
  TEACHER_EMAIL_AMBIGUOUS: 'TEACHER_EMAIL_AMBIGUOUS',
  TEACHER_ID_MISMATCH: 'TEACHER_ID_MISMATCH',
  SESSION_NOT_FOUND: 'SESSION_NOT_FOUND',
  SESSION_NOT_OWNED_BY_TEACHER: 'SESSION_NOT_OWNED_BY_TEACHER',
  STUDENT_NOT_FOUND: 'STUDENT_NOT_FOUND',
  DUPLICATE_REFERENCE_IN_FILE: 'DUPLICATE_REFERENCE_IN_FILE',
  DUPLICATE_REFERENCE: 'DUPLICATE_REFERENCE',
  MONTH_CLOSED: 'MONTH_CLOSED',
  MONTH_NOT_OPEN: 'MONTH_NOT_OPEN',
  PREVIOUS_MONTH_NO_RECORD: 'PREVIOUS_MONTH_NO_RECORD',
  CONFIRM_REQUIRED: 'CONFIRM_REQUIRED',
  POSSIBLE_DUPLICATE: 'POSSIBLE_DUPLICATE'
};

export const VERDICT = {
  VALID: 'VALID',
  NEEDS_CONFIRMATION: 'NEEDS_CONFIRMATION',
  INVALID: 'INVALID'
};

export const RUN_STATUS = { VALIDATED: 'VALIDATED', APPLIED: 'APPLIED', DISCARDED: 'DISCARDED' };

export const MATCHED_BY = { EMAIL: 'EMAIL', UUID: 'UUID' };

export const UPLOAD_LIMITS = {
  MAX_BYTES: 2097152,
  MAX_ROWS: 1000,
  REASON_MAX_LEN: 1024,
  RUNS_LIMIT_DEFAULT: 20,
  RUNS_LIMIT_MAX: 50
};

// CD-202: the apply's "may have been applied" 500 sentence (every other apply 5xx is a confirmed rollback).
export const APPLY_UNSURE_MESSAGE =
  'The upload may have been applied. Reload before trying again; pressing Apply again will not pay twice.';

export const TEMPLATE_FILE_NAME = 'additional_payments_template.csv';
